var React = require('react');

function IcShareLd (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31 16c0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15zm-11.381 5.6h2.895v-5.248a3.264 3.264 0 00-3.257-3.264c-.825 0-2.056.5-2.533 1.274v-1.448h-2.896V21.6h2.896v-4.886c0-.767.5-1.404 1.266-1.404.768 0 1.629.637 1.629 1.404V21.6zM9.486 12.914V21.6h2.895v-8.686H9.486zm2.895-2.895a1.448 1.448 0 10-2.895 0 1.448 1.448 0 002.895 0z","fill":"currentColor"}));
}

IcShareLd.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = IcShareLd;

IcShareLd.default = IcShareLd;
